module.exports = __webpack_public_path__ + "img/linepay.eec2603e.svg";